import React from 'react'

function WhychooseUs() {
  return (
    <div>

        <>
            {/* Start Work Area  */}

            {/* section padding tmp-section-gap */} 

            <div className="work-area work-style-one " style={{
                 paddingBottom: "60px",
                 paddingTop: "60px",
                  }}>
                <div className="container">
                <div className="row">
                    <div className="work-top-inner">
                    <div className="section-head pb-0 section-head-one-side text-align-left">
                        <div className="section-sub-title ">
                        <span className="subtitle">What Makes Vaishnav to Vaishnav Business Network Unique?</span>
                        </div>
                        <h2 className="title c  split-collab">
                        Created to Connect, Collaborate, <br/> and Grow Together 
                        </h2>
                    </div>
                    <div
                        className="single-work-top"
                        data-sal-delay={250}
                        data-sal="slide-up"
                        data-sal-duration={800}
                    >
                        {/* <h2 className="title">4M +</h2>
                        <div className="sub-title">Business Using Stripe</div> */}
                    </div>
                    {/* <div className="scater-line">
                        <img src="assets/images/work/shape.png" style={{ fill: "#f9f9f9" }} alt="" />
                    </div> */}
                    </div>
                </div>
                <div className="row g-5">
                    <div
                    className="col-lg-6 col-md-6"
                    data-sal-delay={150}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    <div className="inner">
                        <a  >
                        <div className="thumbnail">
                            <img
                            className="large"
                            src="assets/images/v2vimages/whychooseSix.jpg"
                            alt="Business Consulting"
                            />
                        </div>
                        </a>
                    </div>
                    </div>
                    <div
                    className="col-lg-3 col-md-6"
                    data-sal-delay={250}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    {/* <div className="single-work style-one mt--35">
                        
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                            />
                            </div>
                            <h3 className="title">Business Consulting</h3>
                            <p className="description">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam.
                            </p>
                        </div>
                        
                    </div> */}
                       <div className="single-work style-one">
                       {/* className="cart-box cart-box-1" */}
                        <a   >
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                            />
                            </div>
                            <h3 className="title" style={{
                                fontSize:"20px",color:'var(--color-primary) !important'
                            }}> Global Connections</h3>
                            <p className="description">
                            Build relationships across industries and borders.
                            </p>
                        </div>
                        </a>
                    </div>
                    <div className="single-work style-one mt--30">
                        <a  >
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                            />
                            </div>
                            <h3 className="title" style={{
                                fontSize:"20px",color:'var(--color-primary) !important'
                            }}>Exclusive Insights</h3>
                            <p className="description">
                            Learn from top entrepreneurs and experts.
                            </p>
                        </div>
                        </a>
                    </div>
                    </div>
                    <div
                    className="col-lg-3 col-md-12"
                    data-sal-delay={350}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    <div className="single-work style-one">
                    {/* className="cart-box cart-box-1" */}
                        <a   >
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                            />
                            </div>
                            <h3 className="title" style={{
                                fontSize:"20px",color:'var(--color-primary) !important'
                            }}>Collaborative Growth</h3>
                            <p className="description">
                            Partnerships that amplify success.
                            </p>
                        </div>
                        </a>
                    </div>
                    <div className="single-work style-one mt--30">
                        <a  >
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                            />
                            </div>
                            <h3 className="title" style={{
                                fontSize:"20px",color:'var(--color-primary) !important'
                            }}>Opportunities to Scale</h3>
                            <p className="description">
                            Unlock new possibilities for your business.
                            </p>
                        </div>
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            {/* End Work Area  */}
        </>

    </div>
  )
}

export default WhychooseUs